/**
 * Maintenance Feature Types
 * Ticket manutenzione, segnalazioni
 */

export type PrioritaTicket = 'Bassa' | 'Media' | 'Alta' | 'Urgente';
export type StatoTicket = 'Aperto' | 'In lavorazione' | 'Risolto' | 'Chiuso';
export type CategoriaTicket = 'Manutenzione' | 'Pulizie' | 'Sicurezza' | 'Ospite' | 'Altro';

export interface TicketManutenzione {
  id: string;
  user_id: string;
  struttura_id?: string;
  struttura_nome?: string;
  camera_id?: string;
  camera_nome?: string;
  titolo: string;
  descrizione?: string;
  categoria: CategoriaTicket;
  priorita: PrioritaTicket;
  stato: StatoTicket;
  assegnato_a?: string;
  assegnato_nome?: string;
  costo_stimato?: number;
  costo_effettivo?: number;
  data_apertura: string;
  data_chiusura?: string;
  note?: string;
  foto?: string[];
  created_at: string;
  updated_at: string;
}

export interface TicketManutenzioneInsert {
  struttura_id?: string;
  camera_id?: string;
  titolo: string;
  descrizione?: string;
  categoria?: CategoriaTicket;
  priorita?: PrioritaTicket;
  stato?: StatoTicket;
  assegnato_a?: string;
  costo_stimato?: number;
  note?: string;
}

export interface TicketManutenzioneUpdate extends Partial<TicketManutenzioneInsert> {}

export interface Segnalazione {
  id: string;
  user_id: string;
  ticket_id?: string;
  struttura_id?: string;
  struttura_nome?: string;
  segnalato_da: string;
  titolo: string;
  descrizione: string;
  categoria: CategoriaTicket;
  urgenza: PrioritaTicket;
  stato: 'Aperta' | 'In corso' | 'Risolta';
  data: string;
  created_at: string;
  updated_at: string;
}

export const PRIORITA_CONFIG: Record<PrioritaTicket, { color: string; bg: string; border: string }> = {
  'Bassa': { color: 'text-emerald-400', bg: 'bg-emerald-500/10', border: 'border-emerald-500/20' },
  'Media': { color: 'text-electric-400', bg: 'bg-electric-500/10', border: 'border-electric-500/20' },
  'Alta': { color: 'text-amber-400', bg: 'bg-amber-500/10', border: 'border-amber-500/20' },
  'Urgente': { color: 'text-rose-400', bg: 'bg-rose-500/10', border: 'border-rose-500/20' },
};

export const STATO_CONFIG: Record<StatoTicket, { color: string; bg: string; border: string }> = {
  'Aperto': { color: 'text-electric-400', bg: 'bg-electric-500/10', border: 'border-electric-500/20' },
  'In lavorazione': { color: 'text-amber-400', bg: 'bg-amber-500/10', border: 'border-amber-500/20' },
  'Risolto': { color: 'text-emerald-400', bg: 'bg-emerald-500/10', border: 'border-emerald-500/20' },
  'Chiuso': { color: 'text-muted-foreground', bg: 'bg-muted', border: 'border-border' },
};

export const CATEGORIA_OPTIONS: CategoriaTicket[] = ['Manutenzione', 'Pulizie', 'Sicurezza', 'Ospite', 'Altro'];
export const PRIORITA_OPTIONS: PrioritaTicket[] = ['Bassa', 'Media', 'Alta', 'Urgente'];
export const STATO_OPTIONS: StatoTicket[] = ['Aperto', 'In lavorazione', 'Risolto', 'Chiuso'];
